// @flow
import React from 'react'
import Button from 'reactstrap/lib/Button'
import Alert from 'reactstrap/lib/Alert'

type ActionDebugRowProps = {
  active?: boolean,
  buttonTexts?: Array<string>,
  buttonActions?: Array<Function>,
}

/**
 * General component
 */
export default class ActionDebugRow extends React.Component<ActionDebugRowProps> {
  static defaultProps = {
    active: false,
    buttonTexts: [],
    buttonActions: [],
  }

  render = () => {
    if (!this.props.active) {
      return null
    }

    return (
      <Alert className='w-100 mb-3' color='info'>
        <div>
          <p>Debug mód</p>
          <div>
            {this.props.buttonTexts && this.props.buttonTexts.map((text, index) => (
              <Button
                color='info'
                key={text}
                onClick={this.props.buttonActions[index]}
                outline
                size='sm'
              >{text}</Button>
            ))}
          </div>
        </div>
      </Alert>
    )
  }
}
